<template #default>
  <div class="page-view">
    <a-card class="page-filter" :bordered="false">
      <a-form layout="inline" @submit.prevent="onSearch">
        <a-form-item label="Code">
          <a-input
            v-model:value="organizationCode"
            placeholder="Enter code..."
            @pressEnter="onSearch"
          />
        </a-form-item>
        <a-form-item label="Status">
          <a-select
            v-model:value="statusCode"
            style="width: 120px"
            allow-clear
            placeholder="All"
          >
            <a-select-option value="A">Active</a-select-option>
            <a-select-option value="I">InActive</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <div class="page-actions">
            <a-button type="primary" @click="onSearch" :loading="loading"
              >Search</a-button
            >
            <a-button v-if="isAdminOrItRole" @click="showAddModal">
              Add
            </a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>

    <div class="page-grid page-grid--h360">
      <AgGridVue
        style="width: 100%; height: 100%"
        :theme="themeBalham"
        :loading="loading"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :gridOptions="gridOptions"
        :rowData="rowData"
      />
    </div>

    <!-- Add/Edit CounterParty Modal -->
    <a-modal
      class="page-modal"
      v-model:visible="addModalVisible"
      :title="isEdit ? 'Edit CounterParty' : 'Add CounterParty'"
      @ok="isEdit ? handleEditOrganization() : handleAddOrganization()"
      @cancel="handleAddCancel"
      :confirmLoading="addLoading"
      destroyOnClose
    >
      <a-form
        :model="addForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        layout="horizontal"
      >
        <a-form-item label="Code" required>
          <a-input
            v-model:value="addForm.organizationCode"
            placeholder="Enter code"
            :disabled="isEdit"
            @input="onOrganizationCodeInput"
          />
        </a-form-item>
        <a-form-item label="Desc">
          <a-input
            v-model:value="addForm.organizationDesc"
            placeholder="Enter description"
          />
        </a-form-item>
        <!--  <template v-if="!isEdit">
          <a-form-item label="Type" required>
            <a-select
              v-model:value="addForm.organizationTypeId"
              placeholder="Select type"
            >
              <a-select-option value="1">CUSTODIAN</a-select-option>
              <a-select-option value="2">COUNTERPARTY</a-select-option>
            </a-select>
          </a-form-item>
        </template> -->
        <!-- <a-form-item label="Fund">
          <a-select
            v-model:value="addForm.fundIdList"
            mode="multiple"
            allow-clear
            placeholder="Selct fund"
            :show-search="true"
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in fundOptions"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="EffectiveFrom">
          <a-date-picker
            v-model:value="addForm.effectiveFromDate"
            style="width: 100%"
            format="YYYY-MM-DD"
            placeholder="Select effective from date"
          />
        </a-form-item>
        <a-form-item label="EffectiveTo">
          <a-date-picker
            v-model:value="addForm.effectiveToDate"
            style="width: 100%"
            format="YYYY-MM-DD"
            placeholder="Select effective to date"
          />
        </a-form-item>
        <!-- <template v-if="!isEdit">
          <a-form-item label="Status">
            <a-select
              v-model:value="addForm.statusCode"
              placeholder="Select status"
            >
              <a-select-option value="A">Active</a-select-option>
              <a-select-option value="I">InActive</a-select-option>
            </a-select>
          </a-form-item>
        </template> -->
      </a-form>
    </a-modal>

    <!-- Detail Edit Modal -->
    <a-modal
      class="page-modal"
      v-model:visible="detailEditModalVisible"
      title="Edit CounterParty"
      @ok="handleDetailEditOk"
      @cancel="handleDetailEditCancel"
      :confirmLoading="detailEditLoading"
      destroyOnClose
    >
      <a-form
        :model="detailEditForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        layout="horizontal"
      >
        <a-form-item label="Type">
          <a-select
            v-model:value="detailEditForm.organizationTypeCode"
            placeholder="Select type"
          >
            <a-select-option
              v-for="opt in typeOptions"
              :key="opt.label"
              :value="opt.value"
            >
              {{ opt.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Status">
          <a-select
            v-model:value="detailEditForm.statusCode"
            placeholder="Select status"
          >
            <a-select-option value="A">ACTIVE</a-select-option>
            <a-select-option value="I">INACTIVE</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, defineExpose, computed } from 'vue'
import { useStore } from 'vuex'
import { themeBalham } from 'ag-grid-community'

import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import {
  counterPartyView_ColumnDefs,
  // detailColumnDefs,
} from '@/views/reference/counterparty/CounterPartyView_ColumnDefs'
import AgEditCellRenderer from '@/components/AgEditCellRenderer.vue'
import organization from '@/api/organization'

const store = useStore()

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
}
/* const detailDefaultColDef = {
  ...defaultColDef,
  enableCellChangeFlash: true,
  refreshCells: true,
} */

defineExpose({
  AgEditCellRenderer,
})

const organizationCode = ref('')
const statusCode = ref(undefined)
const loading = ref(false)
const rowData = ref([])
const gridApi = ref(null)

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

const gridOptions = ref({
  suppressScrollOnNewData: true,

  onGridReady: (params) => {
    gridApi.value = params.api
  },
})
// const getRowId = (params) => {
//   return String(params?.data?.organizationId ?? '')
// }

const isAdminOrItRole = computed(() => {
  const roles = store.getters['auth/getRoleList'] || []
  const roleNames = [...roles].map((r) => r.name)
  return roleNames.includes('SRM_Admin') || roleNames.includes('SRM_IT')
})

/* const fundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds]
    .filter((f) => f.isActive && f.isReal)
    .sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})
const allFundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds].sort((a, b) => a.fundCode.localeCompare(b.fundCode))
}) */

/* const fundOptions = computed(() =>
  isEdit.value ? allFundList.value : fundList.value
)
 */
const columnDefs = counterPartyView_ColumnDefs.map((col) => {
  if (col.field === 'edit') {
    return {
      ...col,
      cellRendererParams: {
        showEditModal: (params) => showEditModal(params),
      },
    }
  }
  return col
})

/* const detailGridColumnDefs = detailColumnDefs.map((col) => {
  if (col.field === 'edit') {
    return {
      ...col,
      cellRendererParams: {
        showEditModal: (row) => showDetailEditModal(row),
      },
    }
  }
  return col
}) */
/* 
const detailCellRendererParams = {
  refreshStrategy: 'rows',
  detailGridOptions: {
    defaultColDef: detailDefaultColDef,
    columnDefs: detailGridColumnDefs,
    getRowId: (params) => {
      return params.data.organizationMappingId + '_' + params.data.legalEntityId
    },
  },
  getDetailRowData: async (params) => {
    const detailData = []
    const organizationMappingList = params.data.organizationMappingList || []
    const legalEntityContractList = params.data.legalEntityContractList || []

    if (
      organizationMappingList.length === 0 ||
      legalEntityContractList.length === 0
    ) {
      return params.successCallback(detailData)
    }

    const fundMap = new Map(allFundList.value.map((f) => [f.fundId, f]))

    organizationMappingList.forEach((map) => {
      legalEntityContractList.forEach((contract) => {
        const fund = fundMap.get(contract.legalEntityId)
        if (fund) {
          detailData.push({
            ...map,
            legalEntityId: contract.legalEntityId,
            fundCode: fund.fundCode,
            legalEntityContactTypeId: contract.legalEntityContactTypeId,
          })
        }
      })
    })

    return params.successCallback(detailData)
  },
} */

const onSearch = async () => {
  loading.value = true
  try {
    const qry = {
      organizationCode: organizationCode.value.trim(),
      statusCode: statusCode.value,
      organizationTypeCode: 'COUNTERPARTY',
    }
    const resp = await organization.getOrganizations(qry)
    const data = resp.data
    rowData.value = Array.isArray(data) ? data : []
    if (rowData.value.length === 0) {
      message.info('No data found.')
    }
  } catch (e) {
    message.error(getErrorMessage(e, 'Query failed'))
  } finally {
    loading.value = false
  }
}

const addModalVisible = ref(false)
const addLoading = ref(false)
const isEdit = ref(false)

const createEmptyForm = () => ({
  organizationCode: '',
  organizationDesc: '',
  organizationTypeCode: 'COUNTERPARTY',
  // fundIdList: [],
  effectiveFromDate: '',
  effectiveToDate: '',
  statusCode: 'A',
})

const addForm = ref(createEmptyForm())

// Add refs for detail modal
const detailEditModalVisible = ref(false)
const detailEditLoading = ref(false)
const detailEditForm = ref({
  organizationTypeCode: 'COUNTERPARTY',
  statusCode: '',
})

const typeOptions = [
  { value: 1, label: 'CUSTODIAN' },
  { value: 2, label: 'COUNTERPARTY' },
]

const showAddModal = () => {
  isEdit.value = false
  addForm.value = createEmptyForm()
  addModalVisible.value = true
}

const showEditModal = (params) => {
  const data = params?.data || params
  isEdit.value = true
  addForm.value = {
    ...data,
    organizationTypeCode: 'COUNTERPARTY',
    // fundIdList: data.legalEntityContractList.map((item) => item.legalEntityId),
    effectiveFromDate: data.effectiveFromDate
      ? dayjs(data.effectiveFromDate)
      : null,
    effectiveToDate: data.effectiveToDate ? dayjs(data.effectiveToDate) : null,
  }
  addModalVisible.value = true
}

const handleAddCancel = () => {
  addModalVisible.value = false
}

const validateRequired = () => {
  const { organizationCode, organizationTypeCode } = addForm.value
  if (!organizationCode || !organizationTypeCode) {
    message.warning('Please fill all required fields.')
    return false
  }
  return true
}

const handleAddOrganization = async () => {
  if (!validateRequired()) return
  addLoading.value = true
  try {
    await organization.createOrganization({ ...addForm.value })
    message.success('Add success')
    addModalVisible.value = false
    onSearch()
  } catch (e) {
    message.error(getErrorMessage(e, 'Add failed'))
  } finally {
    addLoading.value = false
  }
}

const handleEditOrganization = async () => {
  if (!validateRequired()) return
  addLoading.value = true
  try {
    const payload = {
      ...addForm.value,
      effectiveFromDate: addForm.value.effectiveFromDate
        ? dayjs(addForm.value.effectiveFromDate).format('YYYY-MM-DD HH:mm:ss')
        : null,
      effectiveToDate: addForm.value.effectiveToDate
        ? dayjs(addForm.value.effectiveToDate).format('YYYY-MM-DD HH:mm:ss')
        : null,
    }
    /*  payload.legalEntityContractList = addForm.value.fundIdList.map(
      (fundId) => ({
        legalEntityContractId: null,
        organizationId: payload.organizationId,
        legalEntityId: fundId,
        legalEntityContactTypeId: '1', // Default to '1' for now
      })
    ) */
    await organization.updateOrganization(payload)

    /*  const rowIndex = rowData.value.findIndex(
      (r) => r.organizationId === addForm.value.organizationId
    )
    const organizationMappingList =
      rowData.value[rowIndex].organizationMappingList
    const legalEntityContractList =
      rowData.value[rowIndex].legalEntityContractList
    rowData.value[rowIndex] = {
      ...addForm.value,
      effectiveFromDate: addForm.value.effectiveFromDate
        ? dayjs(addForm.value.effectiveFromDate).format('YYYY-MM-DD HH:mm:ss')
        : null,
      effectiveToDate: addForm.value.effectiveToDate
        ? dayjs(addForm.value.effectiveToDate).format('YYYY-MM-DD HH:mm:ss')
        : null,
      organizationMappingList: organizationMappingList,
      legalEntityContractList: legalEntityContractList,
    } */
    message.success('Edit success')

    /*  await nextTick()
    const rowNode = gridApi.value.getRowNode(addForm.value.organizationId)
    gridApi.value.refreshCells({
      rowNodes: [rowNode],
      columns: ['effectiveFromDate', 'effectiveToDate'],
      force: true,
    }) */

    addModalVisible.value = false
    onSearch()
  } catch (e) {
    message.error(getErrorMessage(e, 'Edit failed'))
  } finally {
    addLoading.value = false
  }
}

// Show detail edit modal
/* const showDetailEditModal = (row) => {
  detailEditForm.value = {
    organizationMappingId: row.data.organizationMappingId,
    organizationId: row.data.organizationId,
    organizationTypeId: row.data.organizationTypeId,
    statusCode: row.data.statusCode,
  }
  detailEditModalVisible.value = true
} */

// Save detail edit
const handleDetailEditOk = async () => {
  detailEditLoading.value = true
  try {
    /*  const org = rowData.value.find(
      (row) => row.organizationId === detailEditForm.value.organizationId
    )
    if (org) {
      let organizationMapping = org.organizationMappingList.find((item) => {
        return (
          item.organizationMappingId ===
          detailEditForm.value.organizationMappingId
        )
      })

      if (organizationMapping) {
        organizationMapping.statusCode = detailEditForm.value.statusCode
      }
    } */
    await organization.updateOrganizationMapping(detailEditForm.value)
    detailEditModalVisible.value = false
    message.success('Edit success')

    /* await nextTick()
    const masterNode = gridApi.value.getRowNode(
      detailEditForm.value.organizationId
    )
    const detailGridApi = masterNode.detailNode.detailGridInfo.api
    const detailNode = detailGridApi.getRowNode(
      detailEditForm.value.organizationMappingId
    )
    detailGridApi.redrawRows({
      rowNodes: [detailNode],
      columns: ['fundCode', 'statusCode'],
      force: true,
    }) */
    onSearch()
  } catch (e) {
    message.error('Edit failed')
  } finally {
    detailEditLoading.value = false
  }
}

const handleDetailEditCancel = () => {
  detailEditModalVisible.value = false
}

const onOrganizationCodeInput = (event) => {
  const value = event?.target?.value || ''
  addForm.value.organizationCode = value.toUpperCase()
}

/* const filterOption = (input, option) =>
  option.key.toLowerCase().includes(input.toLowerCase())
   */
</script>
